import { render, staticRenderFns } from "./SendbirdMessage.vue?vue&type=template&id=31017fc8&scoped=true&"
import script from "./SendbirdMessage.vue?vue&type=script&lang=js&"
export * from "./SendbirdMessage.vue?vue&type=script&lang=js&"
import style0 from "./SendbirdMessage.vue?vue&type=style&index=0&id=31017fc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31017fc8",
  null
  
)

export default component.exports